export const languageSelectorClassicStructure = {
  parent: 'SITE_HEADER',
  componentType: 'wysiwyg.viewer.components.LanguageSelector',
  layout: {
    x: 280,
    fixedPosition: false,
    y: 30,
    scale: 1,
    height: 45,
    rotationInDegrees: 0,
    width: 168,
  },
  type: 'Component',
  metaData: {
    pageId: 'masterPage',
    sig: 'x4n-16',
  },
  skin: 'wysiwyg.viewer.skins.LanguageSelectorSkin',
  data: {
    type: 'LanguageSelector',
    metaData: {
      isHidden: false,
      sig: '6gd-44',
      pageId: 'masterPage',
      schemaVersion: '1.0',
      isPreset: false,
    },
  },
  props: {
    itemFormat: 'fullLocalizedName',
    iconType: 'none',
    iconSize: 22,
    alignTabs: 'left',
    displayMode: 'dropdown',
    type: 'LanguageSelectorProperties',
    metaData: {
      schemaVersion: '1.0',
      pageId: 'masterPage',
      sig: '6gd-46',
    },
    hasArrow: true,
    languagesOrder: [],
  },
  mobileHints: {
    modifiedByUser: true,
    type: 'MobileHints',
    metaData: {
      schemaVersion: '1.0',
      isPreset: false,
      isHidden: false,
      pageId: 'masterPage',
      sig: 'x4n-1',
    },
  },
  style: {
    styleType: 'custom',
    componentClassName: 'wysiwyg.viewer.components.LanguageSelector',
    style: {
      propertiesOverride: {},
      properties: {
        backgroundColorHover: 'color_39',
        backgroundColor: 'color_11',
        itemFont: 'font_8',
        'alpha-separatorColor': '0.0',
        boxShadow: '0px 1px 4px 0px rgba(0,0,0,0.6)',
        borderSides: 'none',
        itemSpacing: '5px',
        backgroundColorActive: 'color_39',
        borderWidth: '1',
        borderRadius: '0px 0px 0px 0px',
        itemTextColor: 'color_15',
        separatorColor: 'color_37',
        'alpha-itemTextColorHover': '1',
        'alpha-backgroundColorActive': '0.5',
        itemTextColorHover: 'color_37',
        'alpha-backgroundColorHover': '0.2',
        borderColorHover: 'rgba(32, 32, 32, 1)',
        'alpha-borderColor': '0.6',
        borderColorActive: 'rgba(32, 32, 32, 1)',
        itemTextColorActive: 'color_37',
        'boxShadowToggleOn-boxShadow': 'false',
        'alpha-itemTextColor': '1',
        borderColor: 'color_37',
      },
      propertiesSource: {
        backgroundColorHover: 'theme',
        backgroundColor: 'theme',
        itemFont: 'theme',
        'alpha-separatorColor': 'value',
        boxShadow: 'value',
        borderSides: 'value',
        itemSpacing: 'value',
        backgroundColorActive: 'theme',
        borderWidth: 'value',
        borderRadius: 'value',
        itemTextColor: 'theme',
        separatorColor: 'theme',
        'alpha-itemTextColorHover': 'value',
        'alpha-backgroundColorActive': 'value',
        itemTextColorHover: 'theme',
        'alpha-backgroundColorHover': 'value',
        borderColorHover: 'value',
        'alpha-borderColor': 'value',
        borderColorActive: 'value',
        itemTextColorActive: 'theme',
        'boxShadowToggleOn-boxShadow': 'value',
        'alpha-itemTextColor': 'value',
        borderColor: 'theme',
      },
      groups: {},
    },
    pageId: '',
    compId: '',
    type: 'ComponentStyle',
    metaData: {
      isHidden: false,
      sig: '6gd-47',
      pageId: 'masterPage',
      schemaVersion: '1.0',
      isPreset: false,
    },
    skin: 'wysiwyg.viewer.skins.LanguageSelectorSkin',
  },
  mobileStructure: {
    layout: {
      x: 140,
      fixedPosition: false,
      y: 10,
      scale: 1,
      height: 26,
      rotationInDegrees: 0,
      width: 40,
    },
    metaData: {
      originalCompId: 'comp-mbg964kc',
      author: 'duplicate',
    },
  },
  activeModes: {},
  referredVariants: {},
  activeVariants: [],
} as any;
